type InfoItemProps = {
  label?: string;
  value?: string | number;
};

const InfoItem = ({ label, value }: InfoItemProps) => {
  return (
    <div className="flex w-full text-white justify-between">
      <div className="max-w-1/2">{label}</div>
      <div className="max-w-1/2">{value}</div>
    </div>
  );
};

export default InfoItem;
